<template lang="pug">
  .max-w-320.mx-auto.mx-lg-0
    h4.mb-2 Forgot Password?
    p.fs-14.mb-5 Enter your email and we’ll send you a reset link.

    .alert.alert-danger(v-if="hasError")
      font-awesome-icon(:icon="['fal', 'exclamation-circle']")
      |  {{ errorMessage }}

    el-form(
      :model="forgotPassword"
      status-icon
      :rules="rules"
      ref="forgotPassword"
      @submit.native.prevent="validateForm('forgotPassword')"
    )
      el-form-item(prop="username").mb-4
        el-input(
          v-model="forgotPassword.username"
          type="email"
          placeholder="Enter Your Email"
          auto-complete="off"
          @blur="validateEmail"
        )

      el-form-item.mb-4
        el-button(
          type="primary",
          native-type="submit"
          v-loading.fullscreen.lock="loading"
        ).w-100 Submit

      div
        .fs-12 Already have an account?
        router-link(to="/sign-in").d-block Sign In
</template>

<script>
import authMixin from './AuthMixin';

export default {
  name: 'ForgotPassword',
  mixins: [authMixin],
  data() {
    return {
      forgotPassword: {
        username: '',
        code: '',
        forgot: '',
      },
      loading: false,
      hasError: false,
      errorMessage: '',
      rules: {
        username: [
          { required: true, message: 'Email address is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid Email address', trigger: 'blur' },
        ],
      },
    };
  },

  methods: {
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.cognitoGetCode();
        }
        return false;
      });
    },

    validateEmail() {
      // !!valid returns true/false;
      this.$refs.forgotPassword.validateField('email', (valid) => !!valid);
    },

    cognitoGetCode() {
      this.loading = true;
      this.$Amplify.Auth.forgotPassword(this.forgotPassword.username)
        .then((r) => {
          console.log(r);
          this.$router.push('/reset-password?from=forgotPassword');
        }).catch((e) => {
          console.log(e);
          this.hasError = true;
          this.errorMessage = 'User name not found';
        }).finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
